module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.6-update.1826293c.png";